module.exports = __webpack_public_path__ + "static/img/bg-default-designer-pic.123afb85.png";